import { useEffect, useState } from "react";
import { getSiteContent } from "../services/api";
import Seo from "../components/Seo";
import { loadSection } from "../services/contentSource";
import privacyFallback from "../data/privacyPolicy.json";

const PrivacyPolicy = () => {
  const [data, setData] = useState<any>(null);

  useEffect(() => {
    loadSection("privacyPolicy", privacyFallback as any).then(({ data: main }) => setData(main));
  }, []);

  if (!data) return null;

  return (
    <>
      <Seo
        title="Privacy Policy"
        description="How MindSyncX Labs collects, uses and protects personal data."
        path="/privacy-policy"
      />
      <link rel="stylesheet" href="/assets/css/master-blog-details.css" />
      <main className="terms-area section-spacing">
        <section className="blog-details-area">
          <div className="container">
            <div
              className="mx-legal-prose"
              style={{
                maxWidth: "900px",
                margin: "0 auto",
                padding: "40px 20px",
                fontFamily: "Arial, sans-serif",
                color: "#333",
                lineHeight: "1.7",
                fontSize: "16px",
              }}
            >
              <h2
                style={{
                  fontSize: "32px",
                  fontWeight: "bold",
                  marginBottom: "30px",
                  textAlign: "center",
                }}
              >
                {data.title}
              </h2>

              {data.sections.map((section: any, i: number) => (
                <div key={i}>
                  <h3
                    style={{
                      fontSize: "24px",
                      fontWeight: "bold",
                      marginTop: "30px",
                    }}
                  >
                    {section.heading}
                  </h3>

                  {Array.isArray(section.items) && section.items.length > 0 ? (
                    <ul>
                      {section.items.map((item: string, j: number) => (
                        <li key={j} dangerouslySetInnerHTML={{ __html: item }} />
                      ))}
                    </ul>
                  ) : section.body ? (
                    section.body.split("\n\n").map((para: string, j: number) => (
                      <p key={j} style={{ whiteSpace: "pre-line" }}>{para}</p>
                    ))
                  ) : null}
                </div>
              ))}
            </div>
          </div>
        </section>
      </main>
    </>
  );
};

export default PrivacyPolicy;
